/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import Toast from 'bootstrap/js/dist/toast';
import { fromEvent, take } from 'rxjs';
import { EventTypes } from 'src/app/model/Enums/Toast/event-types';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent implements OnInit {
  @Output() disposeEvent = new EventEmitter();

  @ViewChild('toastElement', { static: true })
  toastEl!: ElementRef;

  @Input()
  type!: EventTypes;

  @Input()
  title!: string;

  @Input()
  message!: string;

  toast!: Toast;

  ngOnInit() {
    this.show();
  }

  show() {
    this.toast = new Toast(
      this.toastEl.nativeElement,
      this.type === EventTypes.Error
        ? {
            autohide: false,
            animation: true,
          }
        : {
            delay: 3000,
            animation: true,
          },
    );

    fromEvent(this.toastEl.nativeElement, 'hidden.bs.toast')
      .pipe(take(1))
      .subscribe(() => this.hide());

    this.toast.show();
    setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide() {
    this.toast.dispose();
    this.disposeEvent.emit();
  }
}
